// src/pages/DatenschutzPage.js
import React from 'react';
import LegalPage from '../components/LegalPage';
import datenschutzUrl from '../content/datenschutz.md';

export default function DatenschutzPage() {
  return <LegalPage title="Datenschutz" contentUrl={datenschutzUrl} showLastUpdated />;
}
